module.exports = __webpack_public_path__ + "img/giftsshop.e6258ba0.svg";